module.exports = __webpack_public_path__ + "static/images/challenge.d5cc25ce6ca38260d91864f440977ffa.jpg";